import { FiShare2, FiUsers, FiTrendingUp } from "react-icons/fi";
import useScrollReveal from "../hooks/useScrollReveal";

const steps = [
  {
    icon: <FiShare2 size={20} />,
    number: "01",
    title: "Share Your Link",
    desc: "Get your unique referral link and share it anywhere — social media, messaging apps, or directly with friends.",
  },
  {
    icon: <FiUsers size={20} />,
    number: "02",
    title: "They Join Vupop",
    desc: "When someone signs up using your referral link, they're connected to your referral account.",
  },
  {
    icon: <FiTrendingUp size={20} />,
    number: "03",
    title: "Earn Together",
    desc: "You'll receive 5% of the revenue generated by referred users for 12 months from the date they join.",
  },
];

const HowItWorks = () => {
  const [labelRef, labelVisible] = useScrollReveal(0.1);
  const [headRef, headVisible] = useScrollReveal(0.1);

  return (
    <section className="px-10 sm:px-4 pb-16 sm:pb-10 mx-auto w-full">
      {/* Eyebrow + heading */}
      <div
        ref={labelRef}
        className={`transition-all duration-700 ease-out ${
          labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <p className="text-[#FFF528] text-xs font-semibold tracking-widest uppercase font-League_Spartan mb-2">
          HOW IT WORKS
        </p>
      </div>
      <div
        ref={headRef}
        className={`transition-all duration-700 delay-100 ease-out ${
          headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        <h2 className="font-[Norwester]  text-white uppercase text-3xl sm:text-2xl mb-8 sm:mb-6">
          Three simple steps
        </h2>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-3 sm:grid-cols-1 md:grid-cols-1 gap-4">
        {steps.map((step, i) => (
          <StepCard key={i} step={step} delay={i * 120} />
        ))}
      </div>
    </section>
  );
};

const StepCard = ({ step, delay }) => {
  const [ref, visible] = useScrollReveal(0.1);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out`}
      style={{
        transitionDelay: `${delay}ms`,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(24px)",
      }}
    >
      <div className="bg-[#111315] border border-[rgba(255,255,255,0.07)] rounded-xl p-5 sm:p-4 h-full flex flex-col gap-4 hover:border-[rgba(255,245,40,0.2)] transition-colors duration-300">
        {/* Top row: icon + number */}
        <div className="flex items-center justify-between">
          <div className="text-[#FFF528]">{step.icon}</div>
          <span className="text-[rgba(255,255,255,0.18)] font-League_Spartan font-bold text-lg">
            {step.number}
          </span>
        </div>
        {/* Title */}
        <h3 className="font-[Norwester]  text-white text-xl sm:text-sm">
          {step.title}
        </h3>
        {/* Desc */}
        <p className="text-[rgba(255,255,255,0.50)] text-sm sm:text-xs font-sans leading-relaxed">
          {step.desc}
        </p>
      </div>
    </div>
  );
};

export default HowItWorks;